const APIv4RegisterResponseAdapter = {
  toCustomerCredentials: v4Response => {
    const {
      response_data
    } = v4Response;
    return {
      customerId: response_data.userID
    };
  },
  toForgotPasswordResponse: v4Response => {
    const {
      response_data
    } = v4Response;
    return response_data;
  },
  toResetPasswordResponse: v4Response => {
    const {
      response_data
    } = v4Response;
    return response_data;
  },
  toSubscribeNewsletterResponse: v4Response => {
    const {
      response_data
    } = v4Response;
    return response_data;
  }
};
export default APIv4RegisterResponseAdapter;
